export const canOwnPrivateDataset = ({
  serviceTierName,
  isCustomPlan,
}: {
  serviceTierName: string | undefined;
  isCustomPlan?: boolean | undefined;
}) =>
  Boolean(
    serviceTierName !== undefined &&
      (["premium", "premium_annually"].includes(serviceTierName) ||
        isCustomPlan)
  );
